import { get } from 'lodash';
import React from 'react';
import ReactDOM from 'react-dom';

import StoreLocation from 'components/StoreLocation';

const StoreLocationController = class {
  static get storeLocation() {
    const data = get(window, ['ALLBIRDS', 'page', 'storeLocation']);

    if (!data) {
      throw new Error('Missing Store Location window data.');
    }

    return data;
  }

  static mountStoreLocationContainer = () => {
    ReactDOM.render(
      <StoreLocation storeLocation={StoreLocationController.storeLocation} />,
      document.getElementById('store-location')
    );
  };

  static init = () => {
    StoreLocationController.mountStoreLocationContainer();
  };
};

export default StoreLocationController;
